<template>
  <div>
    <media-container :issue="issue" :figures="issue.files.figures"></media-container>
    <issue-authors v-bind:authors="issue.authors"></issue-authors>
    <div v-if="issue.abstract" :class="{ hide: !isAbstractShow }" class="abstract">
      <div class="title">ABSTRACT</div>
      <div class="fullText" v-html="issue.abstract"></div>
    </div>
    <div class="article-quick-links" v-if="issue._id">
      <article-quick-links :article="issue"></article-quick-links>
    </div>
  </div>
</template>

<script>
  import ArticleQuickLinks from '@/components/shared/ArticleQuickLinksComponent'
  import IssueAuthors from '@/components/shared/IssueAuthorsComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  import MediaContainer from '@/components/shared/MediaContainerComponent'
  export default {
    name: 'full-issue',
    mixins: [ UtilityMixin ],
    props: ['issue'],
    components: {
      ArticleQuickLinks,
      IssueAuthors,
      MediaContainer
    },
    data () {
      return {
        selectedId: 0,
        isAbstractShow: true,
        selectedUrl: this.getStaticPath('img/temp/slide-1.jpg')
      }
    },
    methods: { // TODO temp method for returm temp issue cover image path, must be removed after use rest service
      selectThis (slideId, $event) {
        this.selectedUrl = $event.target.target
        this.selectedId = slideId
      },
      toggleAbstract () {
        this.isAbstractShow = !this.isAbstractShow
      }
    }
  }
</script>

<style lang="scss" scoped>
  .abstract {
    max-height: 100vh;
    overflow: hidden;
    margin-top: 35px;
    transition: max-height 200ms;
    &.hide {
       max-height: 0;
    }
  }
  .abstract .title {
    font-family: 'Open Sans Condensed', sans-serif;
    font-size: 13px;
    font-weight: 300;
    line-height: 1.31;
    letter-spacing: 0.7px;
    text-align: left;
    color: $primary-color;
    margin-bottom: $spacing-medium;
  }
  .fullText {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    line-height: 1.38;
    color: $accent-color-3;
    margin-bottom: 23.5px;
  }
  .article-quick-links {
    margin-bottom: 58.5px;
  }

</style>



// WEBPACK FOOTER //
// FullIssueComponent.vue?846d922c